import { isEqual, isNil, isNumber, isString } from 'lodash';
import { EditableField, Field } from './Field';

export interface AddressFieldValue {
  title: string;
  subtitle: string;
  googlePlaceId: string;
  coords: {
    lat: number;
    lon: number;
  };
}

export class AddressField implements EditableField {
  readonly address: AddressFieldValue;
  readonly fieldType = 'AddressField';

  constructor(address: AddressFieldValue) {
    this.address = address;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof AddressField && isEqual(this.address, field.address);
  }

  toFieldJson(): any {
    return this.address;
  }

  get isEmpty() {
    return isNil(this.address);
  }

  toDisplayString(): string {
    return this.address.title;
  }

  static fromFieldJson(jsonBlob: any): AddressField | null {
    if (isAddressFieldValue(jsonBlob)) {
      return new AddressField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isAddressFieldValue(jsonBlob: any): jsonBlob is AddressFieldValue {
  return (
    !isNil(jsonBlob) &&
    isString(jsonBlob.title) &&
    isString(jsonBlob.subtitle) &&
    isString(jsonBlob.googlePlaceId) &&
    isNumber(jsonBlob.coords?.lat) &&
    isNumber(jsonBlob.coords?.lon)
  );
}
